import type { CardType } from "@/program/Card";

/** CardType → tokens.css の CSS 変数名 */
export const CARD_CSS_VARS: Record<CardType, string> = {
  forward: "--card-forward",
  turn: "--card-turn",
  if: "--card-if",
  while: "--card-while",
  addToOrb: "--card-add",
  multiplyOrb: "--card-multiply",
  call: "--card-call",
  action: "--card-action",
};

/** CardType → card-d の --c にセットする値 */
export function getCardColor(type: CardType): string {
  const map: Record<CardType, string> = {
    forward: "var(--c-forward)",
    turn: "var(--c-turn)",
    if: "var(--c-if)",
    while: "var(--c-while)",
    addToOrb: "var(--c-add)",
    multiplyOrb: "var(--c-multiply)",
    call: "var(--c-call)",
    action: "var(--c-action)",
  };
  return map[type];
}
